import { useEffect, useState } from 'react'
import BoltRoundedIcon from '@mui/icons-material/BoltRounded'
import type { ChatCommandAction, ChatCommandStatus } from '../../types/chat'
import { useWorkspace } from '../../context/useWorkspace'
import { useNls } from '../../nls/nlsProvider'
import { getChatCommandSummary, processChatCommand } from '../../utils/deltaProcessor'
import { subscribeChatCommand } from '../../services/commandExecutionService'
import { Button } from '../Common'

export const ChatCommandBubble = ({ command }: { command: ChatCommandAction }) => {
  const { canPerform } = useWorkspace()
  const { t } = useNls()
  const [status, setStatus] = useState<ChatCommandStatus>(command.status)
  const [statusMessage, setStatusMessage] = useState('')
  const [isExecuting, setIsExecuting] = useState(false)

  useEffect(() => subscribeChatCommand(command.commandId, (state) => {
    setStatus(state.status)
    setStatusMessage(state.statusMessage)
  }), [command.commandId])

  const execute = async () => {
    setIsExecuting(true)
    setStatusMessage('')
    try {
      await processChatCommand({ ...command, status }, canPerform)
    } catch (error) {
      setStatusMessage(error instanceof Error ? error.message : t('NLSChatErrorActionExecutionFailed'))
    } finally {
      setIsExecuting(false)
    }
  }

  const isFinal = status !== 'PENDING'
  return (
    <section className={`chatCommandBubble is-${status.toLowerCase()}`} aria-label={t('NLSChatAriaCommandAction', { type: command.type })}>
      <header>
        <span><BoltRoundedIcon sx={{ fontSize: 16 }} /> {t('NLSChatLabelOperationalAction')}</span>
        <strong>{status}</strong>
      </header>
      <p>{getChatCommandSummary(command)}</p>
      {statusMessage && <small>{statusMessage}</small>}
      <Button variant="primary" disabled={isExecuting || isFinal} onClick={() => void execute()}>
        {isExecuting ? t('NLSChatStatusExecuting') : status === 'EXECUTED' ? t('NLSChatStatusExecuted') : status === 'REJECTED' ? t('NLSChatStatusRejected') : status === 'FAILED' ? t('NLSChatStatusFailed') : t('NLSChatActionExecute')}
      </Button>
    </section>
  )
}
